import { generateAvatarInitialsImage, IColumn } from '@repo/ui';
import { Progress } from 'reactstrap';

interface PercentageProgressProps {
  percentage: number;
}

const PercentageProgress = ({ percentage }: PercentageProgressProps) => {
  const normalizedPercentage = Math.min(100, Math.max(0, percentage));

  const color =
    normalizedPercentage <= 40
      ? 'success'
      : normalizedPercentage < 70
        ? 'warning'
        : 'danger';

  return (
    <div className="d-flex align-items-center gap-2 w-100">
      <Progress
        value={normalizedPercentage}
        color={color}
        className="flex-fill"
        style={{ height: 8 }}
      />

      <span
        className="fw-semibold text-end"
        style={{ width: 48, flexShrink: 0 }}
      >
        {normalizedPercentage}%
      </span>
    </div>
  );
};

export const makeStudentsRankingColumns = (): IColumn[] => {
  return [
    {
      title: 'Estudantes',
      dataKey: 'studentName',
      width: 260,
      cellRenderer: ({ rowData }) => {
        const studentName = rowData.studentName || '-';
        const fallbackAvatar = generateAvatarInitialsImage(studentName, 40);

        return (
          <div className="d-flex align-items-center gap-3 py-2">
            <img
              src={rowData.studentPhoto || fallbackAvatar}
              alt={studentName}
              style={{
                width: '38px',
                height: '38px',
                borderRadius: '999px',
                objectFit: 'cover',
                flexShrink: 0,
              }}
            />

            <div className="d-flex flex-column text-wrap">
              <div className="fw-semibold text-body">{studentName}</div>

              <div className="text-muted small">
                {rowData.institutionName || '-'}
                {rowData.courseName && ` · ${rowData.courseName}`}
              </div>
            </div>
          </div>
        );
      },
    },
    {
      title: 'Total de Atividades',
      dataKey: 'totalActivities',
      cellRenderer: ({ rowData }) => {
        return (
          <div className="text-end">
            <span>{rowData?.totalActivities ?? 0}</span>
          </div>
        );
      },
    },
    {
      title: 'Atividades Suspeitas',
      dataKey: 'activitiesWithIndicationsCount',
      cellRenderer: ({ rowData }) => {
        return (
          <div className="text-end">
            <span>{rowData?.activitiesWithIndicationsCount ?? 0}</span>
          </div>
        );
      },
    },
    {
      title: 'Porcentagem',
      dataKey: 'activitiesWithIndicationsPercent',
      width: 180,
      cellRenderer: ({ rowData }) => (
        <PercentageProgress
          percentage={Number(rowData.activitiesWithIndicationsPercent ?? 0)}
        />
      ),
    },
  ];
};
